import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BackendConfiguration} from '@application/configuration/backend-configuration';
import {OrderLinesTarget} from '@domain/order-lines-target.enum';
import {OrderLine} from '@domain/orderbook/order-line';
import {PropertyValue} from '@domain/property-value';
import {Orderbook} from '@infrastructure/http/orderbook/orderbook';
import {OverviewListOrderLine} from '@presentation/pages/texfab/orderbook/overview/overview-list-order-line';
import {GroupedOrderLine} from '@presentation/pages/texfab/production-schedule/add/drawing-library/views/order-lines-grouped-view/grouped-order-line';
import {AssertionUtils, GridModel, NotImplementedError} from '@vdw/angular-component-library';
import {Observable} from 'rxjs';
import {map as rxjsMap} from 'rxjs/operators';

@Injectable()
export class HttpOrderbookService implements Orderbook {
  private httpClient: HttpClient;
  private backendConfiguration: BackendConfiguration;

  public constructor(httpClient: HttpClient, backendConfiguration: BackendConfiguration) {
    this.httpClient = httpClient;
    this.backendConfiguration = backendConfiguration;
  }

  public getSlice(target: OrderLinesTarget, gridModel: GridModel, productionScheduleId?: string): Observable<OverviewListOrderLine[]> {
    const scheduleId = AssertionUtils.isNullOrUndefined(productionScheduleId) ? null : productionScheduleId;
    const url = `${this.backendConfiguration.getEndpoint()}order-book/order-lines/get?target=${target}&scheduleIdToExcludeFromToPlanAmount=${scheduleId}`;
    const gridModelJSON = gridModel.toJSON();

    return this.httpClient
      .post(url, gridModelJSON)
      .pipe(rxjsMap((overviewListOrderLinesJSON: any) => overviewListOrderLinesJSON.map((overviewListOrderLine: any) => OverviewListOrderLine.fromJSON(overviewListOrderLine))));
  }

  public delete(id: number | string): Observable<void> {
    return this.httpClient.delete<void>(`${this.backendConfiguration.getEndpoint()}order-book/order-lines/${id}`);
  }

  public getById(id: number | string, target: OrderLinesTarget): Observable<OrderLine> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}order-book/order-lines/${id}?target=${target}`).pipe(
      rxjsMap((orderLineJSON: any) => {
        return OrderLine.fromJSON(orderLineJSON, OrderLinesTarget.ORDER_BOOK === target);
      })
    );
  }

  public getGroupedOrderlines(gridModel: GridModel, groupedBy: string[]): Observable<GroupedOrderLine[]> {
    return this.httpClient
      .post(`${this.backendConfiguration.getEndpoint()}order-book/summary`, {
        groupedBy,
        sortModel: gridModel.sortModel,
        filterModel: gridModel.filterModel
      })
      .pipe(rxjsMap((groupedOrderLinesJSON: any) => groupedOrderLinesJSON.map((groupedOrderLineJSON: any) => GroupedOrderLine.fromJSON(groupedOrderLineJSON))));
  }

  public save(item: OrderLine): Observable<number> {
    throw new NotImplementedError();
  }

  public update(item: OrderLine): Observable<void> {
    throw new NotImplementedError();
  }

  public getListOfCustomSettings(): Observable<PropertyValue[]> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}order-book/custom-settings`).pipe(rxjsMap((response: PropertyValue[]) => response));
  }

  public saveCustomSettings(settings: PropertyValue[]): Observable<void> {
    return this.httpClient.put<void>(`${this.backendConfiguration.getEndpoint()}order-book/custom-settings`, settings);
  }

  public getPossibleValues(columnIdentifier: string): Observable<string[]> {
    return this.httpClient.get(`${this.backendConfiguration.getEndpoint()}order-book/order-lines/${columnIdentifier}/possible-values`).pipe(rxjsMap((response: string[]) => response));
  }
}
